import { type AxiosResponse } from 'axios';

import { type AddUserPoolType, type FactoryType } from '@/types';
import { camelToSnakeCase } from '@/lib/convert-code-style';

import { axiosPatch } from '@/api/AxiosApi';
import { sendRequest } from '@/api/AxiosRequest';
import { type CustomAxiosResponse } from '@/api/AxiosResponse';

export const updateFactory = async (factoryId: string, aData: FactoryType): Promise<CustomAxiosResponse> => {
  const payload = {
    path: `/staking-factory/${factoryId}`,
    body: { ...aData },
  };
  return sendRequest(payload, 'updateFactory', axiosPatch);
};
